import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import AlbumSlideshowGridViewerActionButton from '../../../../components/grid/components/AlbumSlideshowGridViewer/components/AlbumSlideshowGridViewerActionButton';
import ShareIcon from '../../../../components/icons/ShareIcon';
import EditIcon from '../../../../components/icons/EditIcon';
import DropdownMenu from '../../../../components/global/DropdownMenu';
import DotTrigger from '../../../../components/global/DotTrigger';
import Button from '../../../../components/global/Button';
import PublishIcon from '../../../../components/icons/PublishIcon';
import FullScreenIcon from '../../../../components/icons/FullScreenIcon';

const propTypes = {
  authenticated: PropTypes.bool,
  isOwner: PropTypes.bool,
  isContributor: PropTypes.bool,
  onEdit: PropTypes.func,
  onShare: PropTypes.func,
  loading: PropTypes.bool,
  onDelete: PropTypes.func,
  onPublishToggle: PropTypes.func,
  onFullScreenToggle: PropTypes.func,
  isPublished: PropTypes.bool,
  onAddPhotos: PropTypes.func,
};

const AlbumSlideshowViewerActions = ({
  authenticated,
  isOwner,
  isContributor,
  onEdit,
  onShare,
  loading,
  onDelete,
  onPublishToggle,
  onFullScreenToggle,
  isPublished,
  onAddPhotos,
}) => {
  if (!authenticated) {
    return null;
  }

  // Signed up non-owners should only see one thing - Share ability (if sharing is possible)
  if (!(isOwner || isContributor)) {
    return (
      <Fragment>
        {onFullScreenToggle && (
          <AlbumSlideshowGridViewerActionButton
            tooltipId="slideshow-toggle"
            label="Toggle Full Screen"
            icon={<FullScreenIcon />}
            onClick={onFullScreenToggle}
          />
        )}
        {onShare && (
          <AlbumSlideshowGridViewerActionButton
            tooltipId="slideshow-share"
            label="Share"
            icon={<ShareIcon />}
            onClick={onShare}
          />
        )}
      </Fragment>
    );
  }

  if (isContributor) {
    return (
      <Fragment>
        {onShare && (
          <AlbumSlideshowGridViewerActionButton
            tooltipId="slideshow-share"
            label="Share"
            icon={<ShareIcon />}
            onClick={onShare}
          />
        )}
        {onFullScreenToggle && (
          <AlbumSlideshowGridViewerActionButton
            tooltipId="slideshow-toggle"
            label="Toggle Full Screen"
            icon={<FullScreenIcon />}
            onClick={onFullScreenToggle}
          />
        )}
        {onAddPhotos && (
          <div className="dropdown-menu-dark ml-1">
            <DropdownMenu
              toggle={
                <DotTrigger className="is-overlay" dotType="horizontal" />
              }
              placement="bottom-end"
            >
              <Button
                btnStyle="reset"
                className="dropdown-item text-extra-bold"
                onClick={onAddPhotos}
                disabled={loading}
              >
                Add Photos
              </Button>
            </DropdownMenu>
          </div>
        )}
      </Fragment>
    );
  }

  const withDropdown = onDelete || onAddPhotos;

  return (
    <Fragment>
      {onEdit && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="slideshow-edit"
          label="Edit"
          className="d-flex"
          icon={<EditIcon />}
          onClick={onEdit}
        />
      )}
      {onShare && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="slideshow-share"
          label="Share"
          className="d-flex"
          icon={<ShareIcon />}
          onClick={onShare}
        />
      )}
      {onFullScreenToggle && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="slideshow-toggle"
          label="Toggle Full Screen"
          icon={<FullScreenIcon />}
          onClick={onFullScreenToggle}
        />
      )}
      {onPublishToggle && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="slideshow-publish"
          label={isPublished ? 'Unpublish' : 'Publish'}
          className={`d-flex ${isPublished ? 'red-button' : ''}`}
          icon={<PublishIcon />}
          onClick={onPublishToggle}
        />
      )}
      {withDropdown && (
        <div className="dropdown-menu-dark ml-1">
          <DropdownMenu
            toggle={<DotTrigger className="is-overlay" dotType="horizontal" />}
            placement="bottom-end"
          >
            {onDelete && (
              <Button
                btnStyle="reset"
                className="dropdown-item text-extra-bold text-danger"
                onClick={onDelete}
                disabled={loading}
              >
                Delete
              </Button>
            )}
            {onAddPhotos && (
              <Button
                btnStyle="reset"
                className="dropdown-item text-extra-bold"
                onClick={onAddPhotos}
                disabled={loading}
              >
                Add Photos
              </Button>
            )}
          </DropdownMenu>
        </div>
      )}
    </Fragment>
  );
};

AlbumSlideshowViewerActions.propTypes = propTypes;

export default AlbumSlideshowViewerActions;
